import React from 'react';
import Tickets from './index';
import ErrorBoundary from '../../../components/ErrorBoundary';

const HelpButton = React.lazy(() => import('../../../components/HelpButton'));
const TicketCategoriesList = React.lazy(() => import('./TicketCategoriesList'));
const TicketCategoriesPage = () => {
  return (
    <Tickets>
      <ErrorBoundary>
        <React.Suspense fallback={<div />}>
          <>
            <div className="text-right mb-2">
              <HelpButton fileName="tickets-categories" />
            </div>
            <TicketCategoriesList />
          </>
        </React.Suspense>
      </ErrorBoundary>
    </Tickets>
  );
};

export default TicketCategoriesPage;
